module.exports = __webpack_public_path__ + "static/media/4-pin.4700b4ae.svg";